import type { VmvSet } from '@helix/lib';
import { getGraphQLClient, sanitizeGraphQLError } from './graphql-client';

const VMV_QUERY = `
  query Vmv($version: String) {
    vmv(version: $version) {
      version
      vision { title body tags }
      mission { title body tags }
      values { title body tags }
    }
  }
`;

const UPSERT_VMV_MUTATION = `
  mutation UpsertVmv($vision: String!, $mission: String!, $values: [String!]!, $version: String) {
    upsertVmv(vision: $vision, mission: $mission, values: $values, version: $version) {
      version
      vision { title body tags }
      mission { title body tags }
      values { title body tags }
    }
  }
`;

export async function loadVmv(version?: string): Promise<VmvSet> {
  const client = getGraphQLClient();
  try {
    const data = await client.request<{ vmv: VmvSet }>(VMV_QUERY, { version });
    return data.vmv;
  } catch (error: unknown) {
    throw sanitizeGraphQLError(error, 'Vision, mission, and values could not be loaded');
  }
}

export async function saveVmv(
  input: {
    vision: string;
    mission: string;
    values: string[];
    version?: string;
  },
): Promise<VmvSet> {
  const client = getGraphQLClient();
  try {
    const data = await client.request<{ upsertVmv: VmvSet }>(UPSERT_VMV_MUTATION, input);
    return data.upsertVmv;
  } catch (error: unknown) {
    throw sanitizeGraphQLError(error, 'Vision, mission, and values could not be saved');
  }
}
